/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Screen_Open_EquipmentInputs */

const en_us2_onboarding_screen_open_equipment = /** @type {(inputs: Onboarding_Screen_Open_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose my equipment`)
};

const pt_br2_onboarding_screen_open_equipment = /** @type {(inputs: Onboarding_Screen_Open_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolher meus equipamentos`)
};

const es_419_onboarding_screen_open_equipment = /** @type {(inputs: Onboarding_Screen_Open_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir mi equipo`)
};

const pt_pt2_onboarding_screen_open_equipment = /** @type {(inputs: Onboarding_Screen_Open_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolher o meu equipamento`)
};

const fr_fr2_onboarding_screen_open_equipment = /** @type {(inputs: Onboarding_Screen_Open_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir mon matériel`)
};

const de_de2_onboarding_screen_open_equipment = /** @type {(inputs: Onboarding_Screen_Open_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Ausrüstung wählen`)
};

const it_it2_onboarding_screen_open_equipment = /** @type {(inputs: Onboarding_Screen_Open_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli la mia attrezzatura`)
};

/**
* | output |
* | --- |
* | "Choose my equipment" |
*
* @param {Onboarding_Screen_Open_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_screen_open_equipment = /** @type {((inputs?: Onboarding_Screen_Open_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Screen_Open_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_screen_open_equipment(inputs)
	if (locale === "es-419") return es_419_onboarding_screen_open_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_screen_open_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_screen_open_equipment(inputs)
	if (locale === "de-DE") return de_de2_onboarding_screen_open_equipment(inputs)
	if (locale === "it-IT") return it_it2_onboarding_screen_open_equipment(inputs)
	return en_us2_onboarding_screen_open_equipment(inputs)
});
export { onboarding_screen_open_equipment as "onboarding.screen_open.equipment" }